import { formatDuration } from 'date-fns';
import { classNames } from '~/lib';
import { Form } from '../Forms';
import { Heading } from '../Heading';
import { RichText } from '../Molecules';

export const RegistrationCard = ({ content, countdown }) => {
  const parsedCountdown = formatDuration(countdown, {
    format: ['months', 'days', 'hours', 'minutes', 'seconds'],
    zero: true,
    delimiter: ',',
  }).split(',');

  return (
    <div className="w-full max-w-6xl px-4 mx-auto">
      <div className="w-full bg-white rounded-2xl shadow-md border -mt-32 lg:-mt-48 flex flex-col md:flex-row">
        <div className="flex-1 p-5 md:p-12 flex flex-col justify-between space-y-12">
          <div>
            {!!content?.form_title && (
              <Heading as="h6" variant="h4">
                {content?.form_title}
              </Heading>
            )}

            {!!content?.form_subtext && (
              <RichText
                text={content?.form_subtext}
                className="mt-4"
                textClassName="!text-base lg:text-lg leading-7 text-gray-800"
              />
            )}
          </div>

          <div className="flex flex-col items-center">
            <div className="text-sm text-gray-600 uppercase tracking-wider">
              Registration closes
            </div>
            <div className="flex">
              {parsedCountdown.map((countdown, i) => {
                const count = countdown.split(' ');

                const labels = {
                  hours: 'hrs',
                  minutes: 'mins',
                  seconds: 'secs',
                };

                return (
                  <div key={i} className="flex">
                    <div className="flex flex-col items-center">
                      <div className="text-3xl w-12 flex items-center justify-center">
                        {count[0]?.length === 2 ? count[0] : `0${count[0]}`}
                      </div>
                      <div className="text-xs text-gray-600 uppercase tracking-wide">
                        {labels[count[1]] || count[1]}
                      </div>
                    </div>
                    <div
                      className={classNames(
                        'font-serif text-3xl',
                        i === parsedCountdown.length - 1 && 'hidden',
                      )}
                    >
                      :
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="flex-1 p-5 pt-6 md:p-12 border-t md:border-t-0 md:border-l">
          <Form content={content} />
        </div>
      </div>
    </div>
  );
};
